"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LocationForm;
var jsx_runtime_1 = require("react/jsx-runtime");
var form_style = __importStar(require("./LocationForm.module.scss"));
var button_styles = __importStar(require("@components/Buttons/Button.module.scss"));
var react_quill_new_1 = __importDefault(require("react-quill-new"));
require("react-quill-new/dist/quill.snow.css");
var useClearOnTime_1 = __importDefault(require("@hooks/useClearOnTime"));
var react_1 = require("react");
var handleUploadImage_1 = require("@utils/images/handleUploadImage");
var LocationImage_1 = __importDefault(require("@components/Images/LocationImage"));
var react_redux_1 = require("react-redux");
function LocationForm(_a) {
    var _this = this;
    var formData = _a.formData, handleFormSubmit = _a.handleFormSubmit, setFormData = _a.setFormData, language = _a.language;
    var _b = (0, react_1.useState)(""), submitMessage = _b[0], setSubmitMessage = _b[1];
    var characters = (0, react_redux_1.useSelector)(function (state) { return state.charactersSlice; }).characters;
    (0, useClearOnTime_1.default)({ setText: setSubmitMessage, text: submitMessage });
    var uploadMainImage = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var previewUrl_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, handleUploadImage_1.handleUploadImage)(e)];
                case 1:
                    previewUrl_1 = _a.sent();
                    setFormData(function (prev) {
                        var _a;
                        return __assign(__assign({}, prev), { img: previewUrl_1, imageInstance: (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0] });
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    function handleMainImageDelete() {
        setFormData(function (prev) {
            return __assign(__assign({}, prev), { img: "", imageInstance: null });
        });
    }
    function handleInputChange(value, key) {
        setFormData(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[key] = value, _a));
        });
    }
    function submitForm(e) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handleFormSubmit(e)];
                    case 1:
                        res = _a.sent();
                        if (res === false) {
                            setSubmitMessage(language.nameRequired);
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function toggleCharacters(e, character) {
        var isChecked = e.target.checked;
        var updatedCharacters = isChecked
            ? __spreadArray(__spreadArray([], (formData.characters || []), true), [character.id], false) : (formData.characters || []).filter(function (id) { return id !== character.id; });
        setFormData(function (prev) { return (__assign(__assign({}, prev), { characters: updatedCharacters })); });
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("form", { className: form_style.location_form, onSubmit: submitForm, children: [(0, jsx_runtime_1.jsxs)("section", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsxs)("label", { htmlFor: "title", children: [language.name, "*"] }), (0, jsx_runtime_1.jsx)("input", { "data-testid": "test-title", type: "text", id: "title", name: "title", value: formData.name, onChange: function (e) { return handleInputChange(e.target.value, "name"); } })] }), (0, jsx_runtime_1.jsxs)("section", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsxs)("label", { htmlFor: "environment", children: [language.environment, "*"] }), (0, jsx_runtime_1.jsx)("input", { "data-testid": "test-environment", type: "text", id: "environment", name: "environment", value: formData.environment, onChange: function (e) { return handleInputChange(e.target.value, "environment"); } })] }), (0, jsx_runtime_1.jsxs)("section", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "description", children: language.description }), (0, jsx_runtime_1.jsx)(react_quill_new_1.default, { id: "description", className: "", value: formData.description, onChange: function (e) {
                                handleInputChange(e, "description");
                            } })] }), (0, jsx_runtime_1.jsxs)("section", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { children: language.characters }), (0, jsx_runtime_1.jsx)("ul", { className: form_style.characters_list, children: characters.length > 0
                                ? characters.map(function (character) {
                                    var _a;
                                    return ((0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("span", { children: character.name }), (0, jsx_runtime_1.jsx)("div", { className: form_style.input, children: (0, jsx_runtime_1.jsx)("input", { type: "checkbox", value: character.id, checked: ((_a = formData.characters) === null || _a === void 0 ? void 0 : _a.includes(character.id)) || false, onChange: function (e) { return toggleCharacters(e, character); } }) })] }, character.id));
                                })
                                : null })] }), (0, jsx_runtime_1.jsxs)("section", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "main-image", children: language.mainImage }), (0, jsx_runtime_1.jsx)("input", { "data-testid": "test-main-image", type: "file", id: "main-image", name: "title", accept: "image/*", onChange: uploadMainImage }), formData.img && ((0, jsx_runtime_1.jsxs)("div", { style: { marginTop: "10px", position: "relative" }, children: [(0, jsx_runtime_1.jsx)(LocationImage_1.default, { path: formData.img, alt: "Main image", width: "200px" }), (0, jsx_runtime_1.jsx)("button", { onClick: handleMainImageDelete, style: {
                                        position: "absolute",
                                        top: 5,
                                        left: 175,
                                    }, type: "button", children: "x" })] }))] }), submitMessage.length > 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "".concat(form_style.form_group, " ").concat(form_style.error), children: submitMessage })) : null, (0, jsx_runtime_1.jsx)("div", { className: form_style.form_footer, children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: button_styles.create_btn, "data-testid": "test-submit-form", children: language.save }) })] }) }));
}
{
    /*Additional images */
}
{
    /* <section className={form_style.form_group}>
            <label htmlFor="main-image">{language.additionalImages}</label>
            <input
              data-testid="test-main-image"
              type="file"
              id="main-image"
              name="title"
              onChange={uploadAdditionalImages}
            />
            <ul style={{ listStyle: "none", maxHeight: 200, overflowY: "auto" }}>
              {formData.additionalImages && formData.additionalImages.length > 0
                ? formData.additionalImages.map((image: GDDElementImage) => (
                  <li
                    key={image.id}
                    style={{
                      position: "relative",
                      display: "flex",
                      alignItems: "flex-start",
                    }}
                  >
                    <LocationImage
                      path={image.path}
                      alt="additional image"
                      width="150px"
                    ></LocationImage>
                    <button
                      onClick={() => deleteAdditionalImage(image.id)}
                      type="button"
                    >
                      x
                    </button>
                  </li>
                ))
                : null}
            </ul>
          </section> */
}
